import {Component, ComponentRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {OrderItem} from '../../../order/models/order-item';
import {
  ClearPlayersAction, LoadPlayerBySubscriptionBySiteAction,
  LoadPlayersAction, LoadPlayersBySiteAction,
  OrderPlayersByAction,
  QuickSearchPlayersAction,
  SearchPlayersAction,
  ToggleSearchPlayersAction
} from '../../actions/players-list';
import {PlayerFilter} from '../../models/player-filter';
import {combineLatest, Observable, of} from 'rxjs';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {RemovePlayerComponent} from '../remove-player/remove-player.component';
import {RemovePlayerSelectionAction} from '../../actions/remove-player';
import {SiteAddPlayerComponent} from '../site-add-player/site-add-player.component';
import {Site} from '../../../shared/models/site';
import {skipWhile} from 'rxjs/operators';
import * as _ from 'lodash';
import { DefaultPlayerSelectionAction } from '../../actions/default-player';
import { DefaultPlayerComponent } from '../default-player/default-player.component';
import {ModalComponent} from '@storever/modal-confirmation';
import {SetupPlayerAction} from '../../actions/setup-player';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {LoadDeviceModelsAction} from '../../actions/device-models';
import {ResetActivationCodeAction} from '../../actions/reset-activation-code';

@Component({
  selector: 'storever-player-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class PlayerListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {

  componentRef: ComponentRef<SiteAddPlayerComponent>;
  site$: Observable<Site>;
  canAddPlayerMessage: string;
  bsModalRef: BsModalRef;
  // tslint:disable-next-line:no-any
  contentCopy: any;

  @ViewChild('removeModal' , {static: false}) removeModal: RemovePlayerComponent;
  get isMulti(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail-multi/:id'
  }
  get isNewSubscriptionMulti(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail-multi/:id/:subscriptionUuid'
  }
  ngOnInit(): void {
    super.ngOnInit();
    this.loadDataOnChangeUrl('created descending', 'players_site_row_size');
    // this.orderByChanged('created descending');
  //  this.pageSizeChanged(-1);
    this.createDynamicComponent();
    this.canAddPlayer();
   // this.storeSite.dispatch(new SearchPlayersAction(this.filterDeleteIfNilService.flatten(null)));

    if (!this.contentCopy) {
      this.contentCopy =  _.cloneDeep(this.dataConfig.content);
    }
    this.aadColonneIfHistoryIsChecked();
    this.playerShowActivationCodeCol();

  }
  playerShowActivationCodeCol(): void {
    this.site$ = this.storeSite.pipe(select(fromSites.selectors.getSite));
    this.site$.subscribe(site => {
        if (site) {
          // console.log(this.dataConfig.content)
          // console.log(this.dataConfig.content[11])// setup
          // console.log(this.dataConfig.content[12])// reset
          // console.log(this.dataConfig.content[12].icon.hide)// remove

          if ( site.subscriptions[0].product.id === 6 || site.subscriptions[0].product.id === 7) {
            this.dataConfig.content[8].hideTitle = false;
            this.dataConfig.content[9].hideTitle = false;
            this.dataConfig.content[9].hideData = false;
            this.dataConfig.content[10].hideTitle = false;
            this.dataConfig.content[10].hideTitle = false;
           // this.dataConfig.content[12].icon.hide = false;
          } else {
            // if (this.router.url.split('?')[0].search('multi') === -1) {
            //   this.dataConfig.content[8].hideTitle = true;
            //   this.dataConfig.content[9].hideTitle = true;
            //   this.dataConfig.content[9].hideData = true;
            //   this.dataConfig.content[10].hideTitle = true;
            //   this.dataConfig.content[10].hideTitle = true;
            //   //  this.dataConfig.content[12].icon.hide = true;
            // }
            // else {
            //
            //   this.dataConfig.content[9].hideTitle = true;
            //   this.dataConfig.content[9].hideData = true;
            //   this.dataConfig.content[10].hideTitle = true;
            //   this.dataConfig.content[10].hideTitle = true;
            //   //  this.dataConfig.content[12].icon.hide = true;
            // }
          }
          if (site.subscriptions[0].isOrderOpened) {
           // this.dataConfig.content[13].icon.disabled = true;

            for (let j = 0; j < site.subscriptions.length; j++) {
              if (this.activatedRoute.snapshot.paramMap.get('subscriptionUuid') === site.subscriptions[j].uuid) {
                if (site.subscriptions[j].isOrderOpened) {
                  this.dataConfig.content[13].icon.disabled = true;
                } else {
                  this.dataConfig.content[13].icon.disabled = false;
                }
              }
            }
           //  this.contentCopy[14].icon.disabled = true;
          } else {
            if (this.router.url.split('?')[0].search('multi') === -1) {
              this.dataConfig.content[13].icon.disabled = false;
              // this.contentCopy[14].icon.disabled = false;
            }
          }
        }
      }
    );

  }

  aadColonneIfHistoryIsChecked(): void {
    if (!JSON.parse(this.dataConfig.form.get('showHistory').value)) {
        if (this.dataConfig.content[9] && this.dataConfig.content[9].prop ===  'deleted') {
          this.dataConfig.content.splice(8, 2)
        }
    } else {
      this.dataConfig.content = _.cloneDeep(this.contentCopy);
    }
    this.dataConfig.form.markAsUntouched();
  }

  createDynamicComponent(): void {
    this.container.clear();
    const factory = this.resolver.resolveComponentFactory(SiteAddPlayerComponent);
    this.componentRef = this.container.createComponent(factory);
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
    this.storeSite.dispatch(new ClearPlayersAction());
    this.router.navigate( [], { queryParams: {}});
  }

  loadData(): void {
   // this.orderByChanged('created descending');
    if (this.router.url.split('?')[0].search('multi') !== -1) {
      if (this.isNewSubscriptionMulti) {
        this.storeRoot.dispatch(new LoadPlayerBySubscriptionBySiteAction());
      } else {
        this.storeRoot.dispatch(new LoadPlayersBySiteAction());
      }

    } else {
      this.storeRoot.dispatch(new LoadPlayersAction());
    }

  }

  storeSelect(): void {
    this.pageSize$ = of(-1);
    this.count$ = this.storeSite.pipe(select(fromSites.selectors.getPlayersCount));
    this.showFilter$ = this.storeSite.pipe(select(fromSites.selectors.getPlayersShowFilter));
    this.data$ = this.storeSite.pipe(select(fromSites.selectors.getPlayers));
    this.site$ = this.storeSite.pipe(select(fromSites.selectors.getSite));
    this.storeSite.dispatch(new LoadDeviceModelsAction());
  }

  orderByChanged(orderBy: string): void {
    this.storeSite.dispatch(new OrderPlayersByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeSite.dispatch(new SetPreferencesAction({ name: 'players_site_row_size', value: '' + pageSize }));
  }

  applyFilter(filterForm: PlayerFilter): void {
    this.aadColonneIfHistoryIsChecked();
    this.storeSite.dispatch(new SearchPlayersAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeSite.dispatch(new QuickSearchPlayersAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeSite.dispatch(new ToggleSearchPlayersAction(!showFilter));
  }

  dispatchClearDataAction(): void {
    this.storeSite.dispatch(new ClearPlayersAction());
  }

  dispatchToggleSelected(order: OrderItem): void {
    // this.storeSite.dispatch(new TogglePlayersSelectionAction({ uuid:  order.uuid }));
  }

  toggleSelected(order: OrderItem): void {
    // this.storeSite.dispatch(new TogglePlayersSelectionAction({ uuid: order.uuid }));
  }

  routerLink(route: string, data: PlayerFilter): {path: string[], fragment?: string} {
    return
  }

  disablePagination(): boolean {
    return true;
  }

  showModal($event: MouseEvent, modal: any, data: any): void {// tslint:disable-line:no-any
    if (modal === 'removeModal') {
      this.storeSite.dispatch(new RemovePlayerSelectionAction({ deviceID: data.deviceID }));
      this.modalService.show(RemovePlayerComponent);
    } else if (modal === 'resetActivationCode') {
     this.storeSite.dispatch(new ResetActivationCodeAction({ deviceID: data.deviceID }));
    }    else if (modal === 'setDefaultModal') {
      this.storeSite.dispatch(new DefaultPlayerSelectionAction({ deviceID: data.deviceID }));
      this.modalService.show(DefaultPlayerComponent);
    } else if (modal === 'setupModeModal') {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'Are you sure you want to setup this player ?',
        variable: null,
        deleteBtn: false,
        hideBtnOk: true
      };
      this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
          this.storeSite.dispatch(new SetupPlayerAction( data.deviceID ));
        }

      });
      this.subscriptions.push(this.sub$);
    }
  }

  actionButton(type: string): void {
    this.componentRef.instance.open(this.canAddPlayerMessage)
  }

  canAddPlayer(): void {
    const siteSub = this.site$.pipe(
      skipWhile(value => _.isEmpty(value))
    ).subscribe((site: Site) => {
      if (site && site.subscriptions[0] && site.subscriptions[0].isOrderOpened) {
        this.canAddPlayerMessage = 'PLAYER_LIST_ADD_PLAYER_ORDER_OPENED_WARN_TEXT';
      } else if (site && site.subscriptions[0] && site.subscriptions[0].status === 1) { // 1 = OFF
        this.canAddPlayerMessage = 'PLAYER_LIST_ADD_PLAYER_SUB_OFF_WARN_TEXT';
      } else {
        this.canAddPlayerMessage = null;
      }
    });
    this.subscriptions.push(siteSub);
  }

}
